<style lang="less" scoped>
/* .avater {text-align: center;position:absolute;top:0;right:50px;}
   .face {width:100px;height:120px;border:1px solid #dcdcdc;background:#ececec; margin-bottom:15px;
   img {width:100%;height:100%;}
   }*/
.avatar_box {
  text-align: center;
  position: absolute;
  top: 16px;
  right: 50px;
  .avatar {
    width: 120px;
    height: 120px;
    display: inline-block;
    margin: 0 auto;
    border-radius: 50%;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}

.pop { position:relative; 
  .con { display:none; position:absolute; top:31px; left:0;right:0; background:#fff; border-radius:4px; padding:6px 12px; border:1px solid #ebeef5; box-shadow:0 2px 12px 0 rgba(0,0,0,.1); font-size:14px; color:#606266; line-height:1.4; z-index:2;
    &:before { content:''; position:absolute; top:-13px; left:40px; width:0; height:0; border:6px solid transparent; border-bottom-color:#ebeef5;}
    &:after { content:''; position:absolute; top:-10px; left:40px; width:0; height:0; border:6px solid transparent; border-bottom-color:#fff;}
  }

  &:hover .con{ display:block;}
}
</style>
<template>
  <div style="margin-right:200px;">
    <el-form label-width="130px" :model="info" ref="baseForm" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="学校" prop="schoolInfoId">
            <el-select :disabled="true" v-model="info.schoolId">
              <el-option :label="info.school.cnName" :value="info.school.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="校区">
            <el-select :disabled="true" v-model="info.campusId">
              <el-option :label="info.campus.campusName" :value="info.campus.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="角色">
            <div class="pop">
              <el-input :disabled="true" v-model="info.roleConcatName" slot="reference"></el-input>
              <div class="con" v-if="info.roleConcatName.length > 0">{{info.roleConcatName}}</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机构">
            <el-input :disabled="true" v-model="info.orgConcatName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位">
            <el-input :disabled="true" v-model="info.stationConcatName"></el-input>
          </el-form-item>
        </el-col>
      
        <el-col :span="12">
          <el-form-item label="登录账号">
            <el-input :disabled="true" v-model="info.logonName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名">
            <el-input :disabled="true" v-model="info.userName"></el-input>
          </el-form-item>
        </el-col>
     
        <el-col :span="12">
          <el-form-item label="性别" prop="sexCode">
            <el-select :disabled="true" v-model="info.sexCode">
              <el-option :label="info.sexCode | archives_SexText" :value="info.sexCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="idCard">
            <el-input :disabled="true" size="small" v-model="info.idCard"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="工号">
            <el-input :disabled="true" size="small" v-model="info.workNumber"></el-input>
          </el-form-item>
        </el-col> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="身份证件类型" prop="idTypeCode">
            <el-select :disabled="true" v-model="info.idTypeCode">
              <el-option :label="1111" :value="11111"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证件有效期" prop="idcardValidityPeriodList">
            <el-date-picker disabled v-model="info.idcardValidityPeriodList" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row> -->
        <el-col :span="12">
          <el-form-item label="电话">
            <el-input placeholder="电话" v-model="info.contactNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱">
            <el-input placeholder="电子邮箱" v-model="info.mail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="avatar_box">
        <div class="avatar">
          <img :src="avatar_url + info.accountAvatar" @error="errorImg($event,'avatar')">
        </div>
        <div>
          <el-button type="text" @click="upload" class="button">修改头像</el-button>
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="">
            <el-button @click="changeBaseInfo" type="primary">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      role: "",
      roleTea: "",
      isuses: "",
      logoname: "",
      info: {
        id: null,
        logonName: null,
        school: {},
        campus: {},
        // studentNumber:null,
        // studentId:null,
        // gradeDataId:null,
        // classDataId:null,
        // gradationId:null,
        // semesterId:null,
        // schoolYearId:null,
        stationConcatName: null,
        orgConcatName: null,
        roleConcatName: '',
        schoolId: null,
        // userId:null,
        campusId: null,
        // teacherNumberId:null,
        workNumber: null,
        userName: null,
        // englishName:null,
        // nameSpell:null,
        // usedName:null,
        sexCode: null,
        // birthTime:null,
        // birthPlaceCode:null,
        // nativePlace:null,
        // nationalCode:null,
        // nationalityAreaCode:null,
        idTypeCode: null,
        idCardNum: null,
        // maritalStatusCode:null,
        // overseasChineseCode:null,
        // politicalCode:null,
        // healthStatusCode:null,
        // shibieCardNum:null,
        // religiousBeliefCode:null,
        // bloodTypeCode:null,
        accountAvatar: this.$store.state.userInfo.accountAvatar,
        // photos: "",
        idcardValidityPeriodList: null,
        // agencyNumber:null,
        // agencyNumberName:null,
        // homeAdds:null,
        // currentAddress:null,
        // accountLocation:null,
        // accountNatureCode:null,
        // educationCode:null,
        // workDate:null,
        // comeinSchoolDate:null,
        // teachDate:null,
        // plaitTypeCode:null,
        // archivesNum:null,
        // archivesText:null,
        // contactAddress:null,
        contactNumber: null,
        // postalCode:null,
        email: null
        // homePageAddress:null,
        // teacherInfo:null,
        // features:null,
        // workCode:null,
        // schoolWork:null,
        // workLevelCode:null,
        // teachSectionKey:null,
        // jiTeachNumber:null,
        // teacherStatus:null,
        // leavingSchoolLogo:null,
        // leaveSchoolDate:null,
        // auditorId:null,
        // auditDate:null,
        // auditStatus:null,
        // auditIdea:null,
        // remark:null,
        // userLoginName:null,
      },
      upImg: false,
      rules: {
        idCardNum: [{ type: "chinese-id-card", trigger: "blur" }]
      },
      activeTab: "first",
      avatar_url: systemParameter.FILE_SYSTEM_URL + "/file/thumbnail/"
    };
  },
  watch: {
    info: {
      handler(val, oldVal) {
        if (val.accountAvatar != oldVal.accountAvatar) {
          this.info.accountAvatar = val.accountAvatar;
        }
      },
      similar(val, oldVal) {
        if (val.photos != oldVal.photos) {
          this.info.photos = val.photos;
        }
      },
      deep: true
    }
  },
  filters:{
    archives_SexText(val){
      switch (val) {
        case '9':
          return '未说明的性别';
        case '2':
          return '女';
        case '1':
          return '男';
        case '0':
          return '未知的性别';
        default:
          console.warn('vue-filters: archives_SexText: 未知的值: ', val)
          return val;
      }
    }
  },
  mounted() {
    let vm = this;
    http.get(InterfacePrefix['platform']+'/users/personal/'+vm.$store.state.userInfo.id).then(rs => {
      if (rs.data.code) return;


      if(!rs.data.data.school){
        rs.data.data.school={
          cnName: '',
          id: ''
        }
      }
      if(!rs.data.data.campus){
        rs.data.data.campus={
          campusName: '',
          id: ''
        }
      }

      vm.info = rs.data.data;
    });
  },
  methods: {
    upload() {
      let vm = this;
      fileUpload({
        title: "上传头像",
        uploadFileMaxNum: 1,
        formats: "png,jpg,jpeg",
        confirm: function(files) {
          vm.info.accountAvatar = files[0].id;
          vm.upImg = true;
        }
      });
    },
    back() {
      location.reload();
    },
    changeBaseInfo() {
      let vm = this;
      http.put(InterfacePrefix['platform']+'/users/personal', vm.info).then(xhr => {
        if (xhr.data.code) return; // TODO: 异常情况有公共处理
        if (vm.upImg) {
          window.updateFileStatus(vm.info.accountAvatar, function() {
            vm.back();
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/setting/basic_information/basiceInfo.vue